import { Col } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import { Cancel, Print } from "../../../../../utils/Constant";
import { useReactToPrint } from "react-to-print";

const InvoiceSixPrint = ({ contentRef }: { contentRef: React.RefObject<HTMLDivElement | null> }) => {
  const handlePrint = useReactToPrint({
    contentRef,
  });
  return (
    <Col sm="12" className="text-center mt-3">
      <Btn color="primary" className="me-2" onClick={handlePrint}>
        {Print}
      </Btn>
      <Btn color="secondary">{Cancel}</Btn>
    </Col>
  );
};

export default InvoiceSixPrint;
